<div
  class="chatbot-container"
  *ngIf="chatbot$ | async as chatbotState"
  [class.chatbot-side-pane-location]="chatbotState?.isSidePanelOpen"
>
  <div
    class="chatbot-main-container"
    [@mobileSlideState]="
      chatbotState.isMobile
        ? chatbotState.isMinimised
          ? 'mobileClosed'
          : 'mobileOpen'
        : chatbotState.isMinimised
          ? 'desktopClosed'
          : 'desktopOpen'
    "
    [class.full-screen]="chatbotState?.isFullScreen"
    [class.chatbot-open]="!chatbotState?.isMinimised"
    cdkDrag
    cdkDragBoundary="hf-dashboard-template"
  >
    <div cdkDragHandle class="drag-area">
      <hf-chatbot-header
        [class.full-screen]="chatbotState?.isFullScreen"
        [chatbotName]="chatbotName ?? tenantConfigService.chatbotName"
        [isFullScreen]="chatbotState?.isFullScreen"
      ></hf-chatbot-header>
    </div>
    <hf-chatbot-main></hf-chatbot-main>
    <hf-chatbot-footer></hf-chatbot-footer>
  </div>
  <div class="chatbot-icon-container" *ngIf="!chatbotState?.isMobile">
    <div class="chatbot-icon" (click)="openChatbot()">
      <img [src]="tenantConfigService.brandAssetUrl('/assets/icons/chatbot/lily.svg')"
           [alt]="(chatbotName ?? tenantConfigService.chatbotName) + ' chatbot icon'" aria-details="Open chatbot"/>
    </div>
    <ng-container *ngIf="chatbotState?.hasUnreadMessages">
      <hf-unread-icon></hf-unread-icon>
    </ng-container>
  </div>
  <ng-container *ngIf="chatbotState?.isMobile">
    <div class="chatbot-mobile-tag-container" (click)="openChatbot()">
      <img
        [src]="tenantConfigService.isHeron ? '/assets/icons/chatbot/ai-sparkle.svg' : '/assets/icons/chatbot/ai-sparkle-mabel.svg'"
        alt="AI chatbot icon" aria-details="Open chatbot"/>
      <span class="mobile-span-header">{{ tenantConfigService.chatbotName }}</span>
      <ng-container *ngIf="chatbotState?.hasUnreadMessages">
        <hf-unread-icon></hf-unread-icon>
      </ng-container>
    </div>
  </ng-container>
</div>
